// Create a custom format file (e.g., blots/SubmissionPartBlot.ts)
import Quill from "quill";
const Inline = Quill.import("blots/inline");

export class SelectionBlot extends Inline {
  static blotName = "selectionBlot";
  static tagName = "span";
  static className = "selection-blot";

  static create(value: {
    type: "selected" | "highlighted";
    start: number;
    end: number;
    isSelected: boolean;
    criteriaIdentifier?: string;
    relevantInstanceIdentifier?: string;
  }) {
    const node = super.create();

    node.setAttribute("data-selection-blot", "true");
    node.setAttribute("data-selection-start", value.start);
    node.setAttribute("data-selection-end", value.end);
    node.setAttribute("data-is-selected", value.isSelected);

    if (value?.criteriaIdentifier) {
      node.setAttribute("data-criteria-identifier", value.criteriaIdentifier);
    }

    if (value?.relevantInstanceIdentifier) {
      node.setAttribute(
        "data-relevant-instance",
        value.relevantInstanceIdentifier
      );
    }

    // Store the type in a data attribute so it can be accessed from the instance
    if (value?.type) {
      node.setAttribute("data-selection-type", value.type);
    }

    // Apply Tailwind classes based on type
    let classes = " border-t-2 border-b-2"; // base class

    if (value?.type == "selected") {
      classes += " bg-secondary/10 border-secondary";
    } else if (value?.type == "highlighted") {
      classes += " bg-primary/10 border-primary";
    }

    node.className = classes;

    return node;
  }

  static formats(node: HTMLElement) {
    // Return the object that Quill will pass to create()
    const type = node.getAttribute("data-selection-type") as
      | "selected"
      | "highlighted"
      | null;

    if (type) {
      return {
        type,
      };
    }

    return false;
  }

  // Instance method to get the type from the blot instance
  getType(): "selected" | "highlighted" | null {
    if (this.domNode instanceof HTMLElement) {
      return this.domNode.getAttribute("data-selection-type") as
        | "selected"
        | "highlighted"
        | null;
    }
    return null;
  }

  getStart(): number {
    if (this.domNode instanceof HTMLElement) {
      return parseInt(this.domNode.getAttribute("data-selection-start") || "0");
    }
    return 0;
  }

  getEnd(): number {
    if (this.domNode instanceof HTMLElement) {
      return parseInt(this.domNode.getAttribute("data-selection-end") || "0");
    }
    return 0;
  }
}
